export default class PermissionManager {
    constructor(app) {
        this.app = app
        this.collaborator = this.currentCollaborator()
    }

    fullAccess() {
        return this.isAuthorizedToEditAllData()
    }

    isAuthorized(table, document, parentTable, parentDocument) {
        if(this.authorized(table, document)) {
            return true
        }

        if(parentTable && parentDocument && this.authorized(parentTable, parentDocument)) {
            return true
        }

        return  false
    }

    authorized(table, document) {
        if(this.fullAccess()) {
            return true
        }

        let userField = webase.utils.table.getCollaboratorField(table)

        if(userField) {
            let userValue = document[userField.index]

            if(userValue) {
                return userValue.user_id === webase.model.currentUser.id
            }
        }

        if(document['created_by']) {
            let createdBy = document['created_by']

            if(createdBy) {
                return createdBy.id === webase.model.currentUser.id
            }
        }

        return false
    }

    isAuthorizedToEditApp() {
        return this.collaborator.app_permission_id === null || this.collaborator.app_permission_id === 1
    }

    isAuthorizedToEditAllData() {
        return this.collaborator.data_permission_id === 3
    }

    isReadOnly() {
        return this.collaborator.data_permission_id === 5
    }

    appPermission() {
        return this.collaborator.app_permission_id
    }

    dataPermission() {
        return this.collaborator.data_permission_id
    }

    appPermissions() {
        return webase.model.permissions.filter(permission => permission.resource === 'app')
    }

    dataPermissions() {
        return webase.model.permissions.filter(permission => permission.resource === 'data')
    }

    currentCollaborator() {
        for (let i = 0; i < this.app.collaborators.length; i++) {
            let collaborator = this.app.collaborators[i]

            if (collaborator.user_id === webase.model.currentUser.id) {
                return collaborator
            }
        }

        return null
    }

    currentUserRole() {
        let collaborator = this.currentCollaborator()
        return collaborator !== null ? collaborator.role : null
    }

    isOwnerOrAdmin() {
        let collaboratorRole = this.currentUserRole()
        return collaboratorRole === 'owner' || collaboratorRole === 'admin'
    }
}